import { React, useEffect, useState } from "react";
import { Box, Button, Grid } from "@mui/material";
import MenuTab from "../../../component/tabs/MenuTab";
import TerreniForm from "../Terreni/TerreniForm";
import SensoriForm from "../Terreni/SensoriForm";
import LineGraph from "./LineGraph";
// import WeatherCards from "./WeatherCards"
import LocationTable from "./LocationTable";
import "./lineSensori.scss";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanies } from "../../../features/company/companyThunk";
import location from "../../../assets/dashboardIcons/location.png";
import location1 from "../../../assets/dashboardIcons/location1.png";
import WeatherCards from "./WeatherCards";
// import StabilimentoForm from "./StabilimentoForm/StabilimentoForm"
// import SubImposteForm from "../Imposte/SubImposteForm"
const StructureSensori = () => {
  const dispatch = useDispatch();
  const singleData = useSelector((state) => state.sensori.setSingleSensore);
  const [activeTab, setActiveTab] = useState("tab1");
  // State to track the active sub-tab
  const [activeSubTab, setSubActiveTab] = useState("");
  // State to track the selected value
  const [value, setValue] = useState(-1);
  const [activeTab1, setActiveTab1] = useState("Oggi");
   // default to "Oggi"
  const handleSubTabChange = (newTabLabel) => {
    setActiveTab1(newTabLabel);
  };
  console.log("Redux singleData updated:", singleData);
  useEffect(() => {
    dispatch(fetchCompanies());
  }, []);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab); // Update the active tab
    setSubActiveTab(""); // Reset the active sub-tab
    setValue(-1); // Reset the value
  };

  return (
    <>
      <div className="pageTemplate">
        <Grid container spacing={3}>
          <Grid size={{ lg: 3, md: 4, xs: 12 }}>
            <SensoriForm singleData={singleData} />
          </Grid>
          <Grid size={{ lg: 9, md: 8, xs: 12 }}>
            <Box className="realtimeDetection">
              <Box>
                <Box className="btnPart">
                  <Button className="btn darkTheme">
                    Sensore attivo e in registrazione
                  </Button>
                  {/* <Button className="contentText ">
                    Rilevazione in tempo reale
                  </Button> */}
                </Box>
                <WeatherCards />
                {/* <WeatherCards /> */}
              </Box>
              <Box>
                <img
                  src={singleData?.company_id===35 && singleData?.sensore_name === 'seafish' ? location1 : location}
                  alt="Mappa"
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    objectFit: "cover",
                    height: "100%",
                  }}
                />
              </Box>
            </Box>

            <LineGraph />
            {/* <WeatherCards /> */}

            <MenuTab
            //   onTabChange={handleTabChange}
              subSensori={true}
              onTabChange={handleSubTabChange}

            />
            <br />
            <LocationTable filterTab={activeTab1} singleData={singleData}/>
            {/* {Component && <Component />} */}
          </Grid>
        </Grid>
      </div>
    </>
  );
};
export default StructureSensori;